import PropTypes from 'prop-types';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { Button } from 'components/form/Button/Button';
import OText from 'components/CText/OText';

const WebPlusOverviewBannerView = props => {
  const { copyConfig, ctaConfig } = props ?? {};
  const { image, headline, subText } = copyConfig ?? {};
  const { ctaText, disclaimer, onClickCta } = ctaConfig ?? {};
  return (
    <FlexContainer column className="m-hide format100 padT30">
      <FlexContainer
        row
        justifyBetween
        alignItemsCenter
        className="format100 margLRAuto"
      >
        {image && (
          <Label className="format10">
            <img alt={headline} src={image} className="format100" />
          </Label>
        )}
        <FlexContainer column alignItemsStart className="format52">
          {headline && (
            <Label bold className="margB8 text-18 system_neutral_n400_text">
              <OText text={headline} />
            </Label>
          )}
          {subText && (
            <Label className="text-12">
              <OText text={subText} />
            </Label>
          )}
          {disclaimer && (
            <Label className="text-11 fontGray250 margT10 italic">
              <OText text={disclaimer} />
            </Label>
          )}
        </FlexContainer>
        <FlexContainer justifyEnd alignItemsCenter className="format32">
          {ctaText && (
            <Button
              className="padTB10 width-250px"
              onClick={onClickCta}
              mrphType="primary"
              rounded
            >
              <OText text={ctaText} />
            </Button>
          )}
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

WebPlusOverviewBannerView.propTypes = {
  image: PropTypes.string,
  headline: PropTypes.string,
  subText: PropTypes.string,
  ctaConfig: PropTypes.object,
};

export default WebPlusOverviewBannerView;
